import React, { useContext, useState, useEffect } from "react";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import styled from "styled-components";
import { CartContext } from "./context/cart-context";
import PopUp from "./PopUp/PopUp";

const ProductWrapper = styled.div`
  .card {
    border-color: transparent;
    transition: all 0.5s linear;
  }
  .card-footer {
    background: transparent;
    border-top: transparent;
    transition: all 0.5s linear;
  }
  &:hover {
    .card {
      border: 0.04rem solid rgba(0, 0, 0, 0.2);
      box-shadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.2);
    }
    .card-footer {
      background: rgba(247, 247, 247);
    }
  }
  .img-container {
    position: relative;
    overflow: hidden;
  }
  .card-img-top {
    transition: all 0.5s linear;
  }
  .img-container:hover .card-img-top {
    transform: scale(1.2);
  }
  .cart-btn {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0.2rem 0.4rem;
    background: var(--mainGray);
    border-top: 1px solid ${(props) => (props.inStock <= 0 ? "red" : "teal")};
    border-left: 1px solid ${(props) => (props.inStock <= 0 ? "red" : "teal")};
    border-bottom: none;
    border-right: none;
    color: ${(props) => (props.inStock === 0 ? "red" : "teal")};
    font-size: 1.4rem;
    border-radius: 0.5rem 0 0;
    transform: translate(100%, 100%);
    transition: all 0.5s linear;
  }
  .img-container:hover .cart-btn {
    transform: translate(0, 0);
  }
  .cart-btn:hover {
    cursor: pointer;
  }
`;

const ProductCard = (props) => {
  const cart = useContext(CartContext);
  let { id, image, title, price, inStock } = props;
  let [isInCart, setInCart] = useState();
  const [popup, setShowPopup] = useState(false);

  useEffect(() => {
    let selectedProduct = cart.cart.find((item) => item.id === id);
    if (selectedProduct) {
      let index = cart.cart.indexOf(selectedProduct);
      let product = cart.cart[index];
      product.inCart = true;
      setInCart(product.inCart);
    }
  }, [cart.cart, id]);

  const showPopUp = () => {
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
    }, 1000);
  };
  return (
    <React.Fragment>
      <ProductWrapper
        className="col-9 mx-auto col-md-6 col-lg-3 my-3"
        inStock={inStock}
      >
        <div className="card">
          <div className="img-container p-5">
            <img
              src={image}
              alt="Product"
              className="card-img-top"
              style={{ width: "10rem", height: "10rem" }}
            />

            <button
              className="cart-btn"
              disabled={isInCart || inStock <= 0}
              onClick={() => {
                cart.addToCart({ ...props, quantity: 1, total: price });
                setInCart(true);
                showPopUp();
              }}
            >
              {isInCart ? (
                <span
                  className="text-capitalize mb-0"
                  disabled
                  style={{ fontSize: "1rem" }}
                >
                  In cart
                </span>
              ) : (
                <AddShoppingCartIcon />
              )}
            </button>
            {inStock <= 0 ? (
              <div className="text-danger mt-3">Out of Stock</div>
            ) : (
              <div className="text-info mt-3">{inStock} left</div>
            )}
          </div>

          <div className="card-footer d-flex justify-content-between">
            <p className="align-self-center mb-0">{title}</p>
            <h5 className="text-blue font-italic mb-0">
              <span className="mr-1">$</span>
              {price}
            </h5>
          </div>
        </div>
      </ProductWrapper>
      {popup && <PopUp description="Product was added to Cart" productAdded />}
    </React.Fragment>
  );
};

export default ProductCard;
